<ng-container [ngTemplateOutlet]="addAssetInspection"></ng-container>
<ng-container [ngTemplateOutlet]="assetTypeList"></ng-container>
<ng-container *ngIf="isForm">
  <ng-container [ngTemplateOutlet]="recurringJobForm"></ng-container>
</ng-container>

<ng-template #addAssetInspection>
  <div class="row pb-3">
    <div class="col-12 text-right">
      <button class="btn btn-success btn-sm fs-11" (click)="openAssetType()">
        <fa-icon [icon]="['fas', 'plus']"></fa-icon> {{ 'add_asset_inspection' | translate }}
      </button>
    </div>
  </div>
</ng-template>
<ng-template #recurringJobForm>
  <div *ngIf="arSelectedSites.length">
    <div class="row p-3">
      <table class="table border-left border-right border-bottom w-100" style="width: 100% !important;" width="100%">
        <ng-container *ngFor="let site of arSelectedSites; index as siteIndex">
          <ng-container *ngIf="site.asset_type_checklist.length">
            <tr>
              <td colspan="5" width="70%" class="text-center site-title">
                {{ site.text | translate }}
              </td>
            </tr>
            <ng-container *ngFor="let assetType of site.asset_type_checklist; index as assetTypeIndex">
              <tr>
                <td colspan="4" width="70%" class="asset-type-title">
                  {{ assetType.name }}
                </td>
                <td width="25%" class="asset-type-title">
                  <fieldmagic-icon
                    position="center"
                    icon="minus-circle"
                    matTooltip="{{ 'remove_asset_type' | translate }}"
                    class="text-danger cursor-pointer float-right"
                    (click)="removeChecklistInspection(siteIndex, assetTypeIndex)"
                  ></fieldmagic-icon>
                </td>
              </tr>
              <tr>
                <td width="20%" class="align-center" style="width: 25% !important">{{ 'job_summary' | translate }}</td>
                <td width="20%" class="align-center" style="width: 20% !important">{{ 'next_job_date' | translate }}</td>
                <td width="20%" class="align-center" style="width: 20% !important">{{ 'due_date' | translate }}</td>
                <td width="10%" class="align-center" style="width: 10% !important">{{ 'billable' | translate }}</td>
                <td width="25%" class="align-center" style="width: 25% !important">{{ 'assigned_user' | translate }}</td>
              </tr>
              <tr *ngFor="let inspection of assetType.checklist_inspection">
                <td width="20%" class="align-center">
                  {{ inspection.prompt_name }}
                </td>
                <td width="20%" class="align-center">
                  <input-date
                    [objForm]="inspection.form_group"
                    [objItem]="objMetadata['next_job_date']"
                    [strMode]="'add'"
                    [strModule]="'recurring_jobs'"
                    (sendToParent)="childEmitEvent($event)"
                  ></input-date>
                </td>
                <td width="20%" class="align-center">
                  <app-edit-field
                    [item]="objMetadata['due_date']"
                    [strModule]="'recurring_jobs'"
                    [autoSelectResult]="true"
                    [form]="inspection.form_group"
                  ></app-edit-field>
                </td>
                <td width="10%" class="align-center">
                  <app-edit-field
                    [item]="objMetadata['billable']"
                    [strModule]="'recurring_jobs'"
                    [autoSelectResult]="true"
                    [form]="inspection.form_group"
                    [strAdditionalFieldId]="inspection.billable_id"
                  ></app-edit-field>
                </td>
                <td width="25%" class="align-center" style="width: 25% !important">
                  <app-edit-field
                    [item]="objMetadata['user_id']"
                    [strModule]="'recurring_jobs'"
                    [autoSelectResult]="true"
                    [form]="inspection.form_group"
                  ></app-edit-field>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #assetTypeList>
  <ng-container *ngIf="!bLoadingAssetType; else assetTypeLoading">
    <ng-container *ngIf="arAssetTypeList.length; else noRecordFound">
      <mat-accordion>
        <ng-container *ngFor="let site of arAssetTypeList; index as siteIndex">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title matTooltip="{{ 'site' | translate }}: {{ site.text ? site.text : 'no_site' | translate }}">
                {{ site.text ? site.text : 'no_site' | truncate: 80 | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <table class="table mb-0 record-texts fs-11" width="100%">
              <ng-container *ngFor="let asset_type of site.asset_types; index as assetTypeIndex">
                <ng-container>
                  <tr>
                    <td colspan="5">{{ asset_type.text }}</td>
                  </tr>
                  <ng-container *ngIf="asset_type.recurring_jobs.length; else noRecurringJobFound">
                    <ng-container *ngFor="let recurring_job of asset_type.recurring_jobs; index as recurringJobIndex">
                      <tr>
                        <td width="20%" class="truncate">
                          <span matTooltip="{{ 'repeated_every' | translate }}: {{ formatRepeated(recurring_job.repeated_every) | placeholdWithString }}">
                            <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                            {{ formatRepeated(recurring_job.repeated_every) | placeholdWithString }}
                          </span>
                        </td>
                        <td width="25%" class="truncate">
                          <span  matTooltip="{{ 'next_job_date' | translate }}: {{ formatDate(recurring_job.next_job_date) | placeholdWithString }}">
                            <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                            {{ formatDate(recurring_job.next_job_date) | placeholdWithString | truncate }}
                          </span>
                        </td>
                        <td width="15%" class="truncate">
                          <span matTooltip="{{ 'priority' | translate }}: {{ recurring_job.priority | translate }}">
                            <fa-icon [icon]="['far', 'exclamation']" class="px-exclamation"></fa-icon>
                            {{ recurring_job.priority | translate }}
                          </span>
                        </td>
                        <td width="25%" class="truncate">
                          <span matTooltip="{{ 'job_summary' | translate }}: {{ recurring_job.job_summary }}">
                            <fa-icon [icon]="['far', 'align-justify']"></fa-icon>
                            {{ recurring_job.job_summary | truncate}}
                          </span>
                        </td>
                        <td width="10%" class="text-right">
                          <a *ngIf="recurring_job.id"
                            class="pl-1 pr-1 pb-2 pt-2 cursor-pointer"
                            (click)="editRecurringJob(recurring_job)">
                            <fa-icon
                              matTooltipClass="tooltip-space"
                              matTooltip="{{ 'edit' | translate }}"
                              class="text-success"
                              [icon]="['fas', 'pencil']">
                            </fa-icon>
                          </a>
                          <ng-container *fcHasPermission="'recurring_jobs:delete'; else disabledDeleteButton">
                            <a *ngIf="recurring_job.id"
                              class="pl-1 pr-1 pb-2 pt-2 cursor-pointer"
                              (click)="deleteRecurringJob(recurring_job, siteIndex, assetTypeIndex)">
                              <fa-icon
                                matTooltipClass="tooltip-space"
                                matTooltip="{{ 'delete' | translate }}"
                                class="text-warning"
                                [icon]="['fas', 'trash-alt']">
                              </fa-icon>
                            </a>
                          </ng-container>
                          <a *ngIf="recurring_job.id"
                            href="/#/recurring_jobs/{{ recurring_job.id }}"
                            class="pl-1 pr-1 pb-2 pt-2"
                            target="_blank">
                            <fa-icon
                              matTooltipClass="tooltip-space"
                              matTooltip="{{ 'view' | translate }}"
                              class="text-primary"
                              [icon]="['fas', 'eye']">
                            </fa-icon>
                          </a>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </table>
          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #noRecordFound>
  <div *ngIf="isView" class="col-12 text-center no-record-found pt-2">
    {{ 'no_record_found' | translate }}
  </div>
</ng-template>

<ng-template #assetTypeLoading>
  <div class="col-12 text-center">
    <fa-icon [icon]="['fas','spinner']" [spin]="true" aria-hidden="true"></fa-icon>
  </div>
</ng-template>

<ng-template #disabledDeleteButton>
  <button type="button" class="btn btn-warning" disabled>
    <fa-icon [icon]="['fas', 'trash-alt']" class="white"></fa-icon>
    <span class="pl-1" matTooltip="{{ 'forbidden_action_error' | translate }}">{{ 'delete' | translate }}</span>
  </button>
</ng-template>

<ng-template #noRecurringJobFound>
  <tr>
    <td colspan="5" class="text-center">
      {{ 'no_record_found' | translate }}
    </td>
  </tr>
</ng-template>